// @ts-nocheck
import * as React from 'react'
import { withTranslation } from 'react-i18next'
// @ts-ignore
import SVG from 'react-inlinesvg'
import { withRouter } from 'react-router'
import ICON_CARET from "../../../assets/caret.svg";
import moment from 'moment'
import { connect } from 'react-redux'
import { compose } from 'redux'
import classnames from 'classnames'
import './styles.scss'
import { ISelect } from '../../SelectV2/types'
import { SelectV2 } from '../../SelectV2'
import { ButtonMultipleChoices } from '../../ButtonMultipleChoices'
import { Dropdown } from '../../Dropdown'
import FormatText from '../../../helpers/FormatText'

export enum Constants {
  DATEPICKER_FILTER_THIS_MONTH = "DATEPICKER_FILTER_THIS_MONTH",
  DATEPICKER_FILTER_MONTH_TO_DATE = "DATEPICKER_FILTER_MONTH_TO_DATE",
  DATEPICKER_FILTER_PREVIOUS_MONTH = "DATEPICKER_FILTER_PREVIOUS_MONTH",
  DATEPICKER_FILTER_ONE_WEEK = "DATEPICKER_FILTER_ONE_WEEK",
  DATEPICKER_FILTER_PREVIOUS_WEEK = "DATEPICKER_FILTER_PREVIOUS_WEEK",
  DATEPICKER_FILTER_QUARTILE = "DATEPICKER_FILTER_QUARTILE",
  DATEPICKER_FILTER_PREVIOUS_QUARTILE = "DATEPICKER_FILTER_PREVIOUS_QUARTILE",
  DATEPICKER_FILTER_CURRENT_YEAR = "DATEPICKER_FILTER_CURRENT_YEAR",
  DATEPICKER_FILTER_PREVIOUS_YEAR = "DATEPICKER_FILTER_PREVIOUS_YEAR",
  SET_DATEPIKER_FROM_DATE = "SET_DATEPIKER_FROM_DATE",
  SET_DATEPIKER_TO_DATE = "SET_DATEPIKER_TO_DATE",
  SET_DATEPIKER_ENTERED_TO_DATE = "SET_DATEPIKER_ENTERED_TO_DATE",
  SET_DATEPIKER_MONTH_RANGE = "SET_DATEPIKER_MONTH_RANGE",
  DATEPICKER_FILTER_CUSTOM_GLOBAL_STATE = "DATEPICKER_FILTER_CUSTOM_GLOBAL_STATE",
}

export const PATTERN_DATEPICKER = [
  { label: "this_month", value: Constants.DATEPICKER_FILTER_THIS_MONTH },
  {
    label: "previous_month",
    value: Constants.DATEPICKER_FILTER_PREVIOUS_MONTH,
    role: 100,
  },
  { label: "1w", value: Constants.DATEPICKER_FILTER_ONE_WEEK, role: 100 },
  { label: "previous_week", value: Constants.DATEPICKER_FILTER_PREVIOUS_WEEK },
  { label: "Qtd", value: Constants.DATEPICKER_FILTER_QUARTILE },
  {
    label: "previous_quartile",
    value: Constants.DATEPICKER_FILTER_PREVIOUS_QUARTILE,
  },
  { label: "1y", value: Constants.DATEPICKER_FILTER_CURRENT_YEAR },
  { label: "previous_year", value: Constants.DATEPICKER_FILTER_PREVIOUS_YEAR },
  { label: "", value: Constants.DATEPICKER_FILTER_MONTH_TO_DATE },
];

export class FilterHeader extends React.PureComponent<any, any> {
  refDropDown: any
  refSelectPeriod: any
  refSelectGroupBy: any
  refSelectGenerate: any
  refSelectStatus: any
  refSelectTemporality: any

  static getParameters(parameters: string) {
    const params = parameters.split('?')[1]

    const separateEachFilters = params?.split('&')

    let arrayOfFilters: any = []

    separateEachFilters?.forEach((item) => {
      const getLabel = item.split('=')[0]
      const getValues: any = item
        .split('=')[1]
        ?.split(',')
        .map((el) => {
          if (Number(el)) {
            return Number(el)
          }

          return el
        })


      if (!getLabel === 'search' && getValues[0].lenght !== 0) {
        arrayOfFilters = [
          ...arrayOfFilters,
          {
            value: getValues,
            label: getLabel,
          },
        ]
          .filter(el => el.value !== undefined)
      }
    })

    return arrayOfFilters
  }

  constructor(props: any) {
    super(props)

    this.state = {
      openCustomFilters: {},
      isOpenFilters: false,
      isOpenDropdown: false,
      isActiveGroupBy: 0,
      isCloseDatePicker: false,
      isOpenDropdownGroupBy: false,
      isOpenDropdownPeriod: false,
      isOpenDropdownStatus: false,
      isOpenDropdownTemporality: false,
      isOpenMultiChoise: {},
      from: null,
      to: null,
      labelGroupBy: "",
      labelPeriod: {},
      labelStatus: "",
      labelTemporality: "",
      onClickFilter: false,
      isDateUpdate: false,
      isFocus: false,
      filters: null,
      marginTop: 0,
      filters: {
        name: "",
        status: null,
        groupBy: "",
        temporality: "",
      },
    };

    this.refDropDown = React.createRef()
    this.refSelectPeriod = React.createRef()
    this.refSelectGroupBy = React.createRef()
    this.refSelectTemporality = React.createRef()
    this.refSelectGenerate = React.createRef()
    this.refSelectStatus = React.createRef()

    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.onHandlePatternDate = this.onHandlePatternDate.bind(this)
    this.onHandleResetFilters = this.onHandleResetFilters.bind(this)
    this.onHandleResetStatus = this.onHandleResetStatus.bind(this)
    this.onHandleResetPeriod = this.onHandleResetPeriod.bind(this)
    this.numberActiveFilters = this.numberActiveFilters.bind(this)
    this.renderInitialeValue = this.renderInitialeValue.bind(this)
    this.onHandleFocus = this.onHandleFocus.bind(this)
    this.formattingFilters = this.formattingFilters.bind(this)
    this.onHandleStatus = this.onHandleStatus.bind(this)
    this.onHandleGroupBy = this.onHandleGroupBy.bind(this)
    this.onHandleResetGroupBy = this.onHandleResetGroupBy.bind(this)
    this.onHandleResetTemporality = this.onHandleResetTemporality.bind(this)
    this.onHandleTemporality = this.onHandleTemporality.bind(this)
    this.onRenderFilters = this.onRenderFilters.bind(this)
    this.onHandleResetFilter = this.onHandleResetFilter.bind(this)
    this.resetElement = this.resetElement.bind(this)
  }

  /**
   * @name componentDidMount
   * @description React Lifecycle
   * @author Jonathan IBOR
   * @memberof Header
   */
  componentDidMount() {
    document.addEventListener('mousedown', (e) => this.handleClickOutside(e))
    let filterValue = {
      name: '',
    }

    let isOpen = this.props.CONFIG_FILTERS.map((el) => isOpen = {...isOpen, [el.key]: false})

    this.setState({
      isOpenMultiChoise: isOpen,
    })

    if (this.state.filters["status"]) {
      this.setState({
        filters: {
          ...this.state.filters,
          status: Number(this.props.filters["status"]),
        },
      });
    }

    // const queryParams = FilterHeader.getParameters(this.props.location.search)

    /* queryParams.forEach(
      (element: ISelect) => {
        if (element.label === "date") {
          const dateElement = PATTERN_DATEPICKER.map((el: any) => ({
            ...el,
            label:
              el.label === "" ? "" : this.props.t(`datepicker.${el.label}`),
          })).find((el: any) => el.value === element.value[0]);

          this.setState({ labelPeriod: dateElement });
        }

        if (element.label === 'name') {
          filterValue = {
            ...filterValue,
            name: element.value,
          }
        }

        if (element.label === 'status') {
          filterValue = {
            ...filterValue,
            status: element.value[0],
          }

          console.log('here : ', filterValue, this.props)
        }

        const data_key = this.props.CONFIG_FILTERS.find(el => el.key === element.label)

        if (data_key?.withSearch) {
          filterValue = {
            ...filterValue,
            [element.label]: element.value[0],
          }
        }

        const values = data_key && this.props[data_key?.data]?.map((el) => el.value) || []

        if (!data_key && values.includes(element.value[0].toString())) {
          filterValue = {
            ...filterValue,
            [element.label]: element.value[0],
          }
        }
      }
    ); */

    /* this.props.CONFIG_FILTERS?.map((el) => {
      if (el.defaultValue && !queryParams.find(item => item.label === el.key)) {
        filterValue = {
          ...filterValue,
          [el.key]: el.defaultValue.value
        }
      }
      else {
        filterValue = {
          ...filterValue,
          [el.key]: queryParams.find(item => item.label === el.key)?.value,
        }
      }
    }) */

    /* if (this.props.withStatus) {
      // this.setState({ labelStatus: this.props.statusList?.find(item => item.value === filterValue.status) })
    }

    this.setState({ filters: filterValue }) */
  }

  /**
   * @name componentDidUpdate
   * @description React LifeCycle
   * @author Jonathan IBOR
   * @param {Props} nextProps
   * @memberof Header
   */
  componentDidUpdate(nextProps: any, nextState: any) {
    const queryParams = FilterHeader.getParameters(this.props.location.search);

    if (this.props.currentDatePattern !== nextProps.currentDatePattern) {
      if (!this.props.currentDatePattern) {
        this.setState({ labelPeriod: {} })
      }
    }
    if (this.state.labelPeriod?.value !== nextState.labelPeriod?.value) {
      if (Object.entries(this.state.labelPeriod)?.length > 0) {
        this.props.onHandleUpdateDate(this.state.labelPeriod.value)
      }
    }

    if (
      Number(this.state.filters["status"]) !==
      Number(nextState.filters["status"])
    ) {
      const status = this.props.statusList.find(
        (item) => item.value === this.props.filters["status"]
      );

      this.setState({
        filters: {
          ...this.state.filters,
          status: status.value,
        },
      });

      this.props.onGenerate({
        status: status.value,
      });
    }

    if (this.props.filters && this.props.filters["status"]) {
      if (
        (this.props.filters["status"] &&
          Number(this.props.filters["status"])) !==
        (nextProps.filters["status"] && Number(nextProps.filters["status"]))
      ) {
        const status = this.props.statusList.find(
          (item) => item.value === this.props.filters["status"]
        );

        this.setState({
          labelStatus: status,
        });
      }
    }

    if (
      this.state.filters["search"]?.length !==
      nextState.filters["search"]?.length
    ) {
      this.props.onGenerate({
        search: this.state.filters["search"],
      });
    }

    if (this.props.isReset !== nextProps.isReset) {
      this.onHandleResetFilters()
    }
  }

  /**
   * @name handleClickOutside
   * @description
   * @author Jonathan IBOR
   * @param {*} event
   * @memberof Header
   */
  handleClickOutside(event: any): void {
    this.setState({ test: true })
    if (this.refSelectStatus && !this.refSelectStatus?.current?.contains(event.target)) {
      this.setState({ isOpenDropdownStatus: false })
    }

    if (this.refSelectPeriod && !this.refSelectPeriod?.current?.contains(event.target)) {
      this.setState({ isOpenDropdownPeriod: false })
    }

    if (this.refSelectGenerate && !this.refSelectGenerate?.current?.contains(event.target)) {
      this.setState({ isOpenDropdown: false })
    }

    if (this.refSelectGroupBy && !this.refSelectGroupBy?.current?.contains(event.target)) {
      this.setState({ isOpenDropdownGroupBy: false })
    }

    if (this.refSelectTemporality && !this.refSelectTemporality?.current?.contains(event.target)) {
      this.setState({ isOpenDropdownTemporality: false })
    }

    this.props.CONFIG_FILTERS.map(el => {
      if (this.state.test && this[`ref_${el.key}`] && !this[`ref_${el.key}`]?.contains(event.target)) {
        this.setState({
          isOpenMultiChoise: {
            [el.key]: false,
          },
        })
      }
    })
  }

  /**
   * @name onHandlePatternDate
   * @description
   * @author Jonathan IBOR
   * @param {ISelect} type
   * @memberof Header
   */
  onHandlePatternDate(type: ISelect): void {
    this.props.setPeriodWithMonthRange(type.value)
    this.setState({ isOpenDropdownPeriod: !this.state.isOpenDropdownPeriod, labelPeriod: type })
  }

  /**
   * @name onHandleResetFilters
   * @description
   * @author Jonathan IBOR
   * @param {boolean} reset
   * @memberof Header
   */
  onHandleResetFilters(reset: boolean): void {

    this.setState({ labelGroupBy: {}, labelPeriod: {}, filters: {}, labelStatus: '' })

    this.props.history.push(this.props.path)
    this.props.onHandleReset(true)
  }

  /**
   * @name onHandleResetPeriod
   * @description
   * @author Jonathan IBOR
   * @memberof Header
   */
  onHandleResetPeriod(): void {
    const params = FilterHeader.getParameters(
      this.props.location.search
    ).filter((item: ISelect) => item.label !== "date");

    let newFilters = ''

    params.forEach((element: any) => {
      newFilters += `${element.label}=${(element?.value.join(','))}&`
    })

    this.props.history.push(`${this.props.path}?${newFilters}`)

    this.setState({ labelPeriod: {} })
  }

  /**
   * @name componentWillUnmount
   * @description React Lifecycle
   * @author Jonathan
   * @memberof Header
   */
  componentWillUnmount(): void {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  numberActiveFilters() {
    const excludeCount: string[] = ['from', 'to', 'currentPage', 'pagesCount', 'perPage', 'totalCount']

    const activeFilters = this.props?.location?.search
      ?.split('?')[1]
      ?.split('&')
      .filter((item: string) => {
        if (excludeCount.includes(item.split('=')[0]) || item === '') {
          return false
        }

        return true
      })

    if (activeFilters) {
      return activeFilters?.length
    }

    return 0
  }

  renderInitialeValue(select, item) {
    const { statusList } = this.props
    const { filters } = this.state

    if (filters[item]) {
      if (select) {
        if (!Array.isArray(filters?.status)) {
          return [statusList?.find(el => el?.value === filters?.status?.toString())]
        }
      }

      if (!select) {
        if (filters[item]?.length > 0) {
          return [{ value: this.state.filters[item], label: this.state.filters[item] }]
        }

        return []
      }
    }
    return
  }

  onHandleFocus(select: any, bool: boolean) {
    if (select) {
      return this.setState({
        isFocus: bool,
      })
    }

    return
  }

  formattingFilters(value, item) {
    this.setState({
      isOpenMultiChoise: {
        [item.key]: false,
      }
    })

    if (!value) {
      return this.setState({
        filters: {
          ...this.state.filters,
          [item.key]: [],
        },
      })
    }

    if (typeof value === 'string' || typeof value === 'number') {
      return this.setState({
        filters: {
          ...this.state.filters,
          [item.key]: value,
        },
      })
    }

    return this.setState({
      filters: {
        ...this.state.filters,
        [item.key]: value?.[0]?.value,
      },
    })
  }

  resetElement(type: string, state: any) {
    const params = FilterHeader.getParameters(
      this.props.location.search
    ).filter((item: ISelect) => item.label !== type);

    let newFilters = "";

    params.forEach((element: any) => {
      newFilters += `${element.label}=${element?.value.join(",")}&`;
    });

    this.props.history.push(`${this.props.path}?${newFilters}`);

    this.setState(state);
  }

  onHandleResetStatus() {
    this.resetElement("status", { labelStatus: {}, filters: { status: "" } });

    this.props.onGenerate(params)

    this.props.getFilters({
      ...this.props.filters,
      ...this.state.filters,
      status: '',
    })
  }

  onHandleResetGroupBy() {
    this.resetElement('groupBy', { labelGroupBy: {} });
  }

  onHandleResetTemporality() {
    this.resetElement("temporality", { labelTemporality: {} });
  }

  onHandleStatus(type: ISelect): void {
    this.setState({
      isOpenDropdownStatus: !this.state.isOpenDropdownStatus, labelStatus: type, filters: {
        ...this.state.filters,
        status: type.value,
      }
    })

    const statusFilters = {
      ...this.props.filters,
      ...this.state.filters,
      status: type.value,
    };

    this.props.getFilters(statusFilters);
    this.props.onGenerate(statusFilters);
  }

  onHandleGroupBy(type: ISelect): void {
    this.setState({
      isOpenDropdownGroupBy: !this.state.isOpenDropdownGroupBy, labelGroupBy: type, filters: {
        ...this.state.filters,
        groupBy: type.value,
      }
    })

    const groupByFilters = {
      ...this.props.filters,
      ...this.state.filters,
      groupBy: type.value,
    };

    this.props.getFilters(groupByFilters);
    this.props.onGenerate(groupByFilters);
  }

  onHandleTemporality(type: ISelect): void {
    this.setState({
      isOpenDropdownTemporality: !this.state.isOpenDropdownTemporality, labelTemporality: type, filters: {
        ...this.state.filters,
        temporality: type.value,
      }
    })

    const temporalityFilters = {
      ...this.props.filters,
      ...this.state.filters,
      temporality: type.value,
    };

    this.props.getFilters(temporalityFilters);
    this.props.onGenerate(temporalityFilters);
  }

  onHandleResetFilter(item): void {
    const params = FilterHeader.getParameters(
      this.props.location.search
    ).filter((el: ISelect) => el.label !== item.key);

    let newFilters = ''

    params.forEach((element: any) => {
      newFilters += `${element.label}=${(element?.value.join(','))}&`
    })

    this.props.history.push(`${this.props.path}?${newFilters}`)

    this.setState({
      filters: {
        ...this.state.filters,
        [item.label]: null
      }
    })
  }

  onRenderFilters(item, key, isText) {
    const { t } = this.props

    if (isText) {
      const value = Array.isArray(this.props.filters[item.key])
        ? this.props.filters[item.key][0]
        : this.props.filters[item.key]
        ? this.props.filters[item.key]
        : this.props[item.key];

      return (
        <div key={key} className="mr-10">
          <SelectV2
            type={!item.isSelect ? "text" : ""}
            placeholder={t(`formPlaceholder.${item.label}`)}
            data={this.props[item.key] ? this.props[item.key] : null}
            getElements={(el) => this.formattingFilters(el, item)}
            isFocus={
              !item.isSelect && item.withSearch ? this.state.isFocus : false
            }
            initialValues={value ? value.replace(/[^\x00-\x7F]/g, "") : ''}
            icon={<SVG src={FormatText.formatSVGBase64(ICON_CARET)} />}
            multi={item.multi || false}
            handleBlur={(e: any) => this.onHandleFocus(!item?.isSelect, false)}
            handleFocus={(e: any) => this.onHandleFocus(!item?.isSelect, true)}
            secondary
            isHeaderButton
            withSearch={item.withSearch}
            isSelected={this.state.filters[item.key] ? true : false}
          />
        </div>
      );
    }

    return (
      <div className={key !== 0 && "ml-10 priority"}>
        <ButtonMultipleChoices
          label={this.state.filters[item.label]?.toString().length > 0 ? this.state.filters[item.label] : t(`formPlaceholder.${item.label}`)}
          color="default"
          onHandlePrimaryButton={() => this.setState({ isOpenMultiChoise: { [item.key]: !this.state.isOpenMultiChoise[item.key]} })}
          onHandleSecondaryButton={() => this.setState({ isOpenMultiChoise: { [item.key]: !this.state.isOpenMultiChoise[item.key]} })}
          reset={this.state.filters[item.label]?.toString().length > 0 ? false : true}
          isSelected={this.state.filters[item.label]?.toString().length > 0 ? true : false}
          resetElements={() => this.onHandleResetFilter(item)}
          headerButton
        >
          {
            this.state.isOpenMultiChoise[item.key] && (
              <div ref={el => this[`ref_${item.key}`] = el} style={{ position: 'absolute', left: '0', top: '105%' }}>
                <Dropdown
                  data={this.props[item.data] ? this.props[item.data] : null}
                  selectedItems={(el) => this.formattingFilters(el.value, item)}
                />
              </div>
            )
          }
        </ButtonMultipleChoices>
      </div>
    )
  }

  render() {
    const { t, isOpenFilters, onOpenFilters, CONFIG_FILTERS, withPeriod, withFilters } = this.props

    const {
      isActiveGroupBy,
      labelPeriod,
      labelStatus,
      labelGroupBy,
      labelTemporality,
      isOpenMultiChoise,
      filters,
    } = this.state

    return (
      <React.Fragment>
        <div style={{ display: 'flex', width: '100%' }}>
          {CONFIG_FILTERS?.map((item: any, i: number) => {
            if (!item.isFilters) {
              return this.onRenderFilters(item, i, item.withSearch)
            }
            return;
          })}
          { this.props.withGroupBy && (
            <div ref={this.refSelectGroupBy} className="mr-10 priority">
              <ButtonMultipleChoices
                label={
                  labelGroupBy?.label?.length > 0 ? labelGroupBy?.label : "Type"
                }
                color="default"
                onHandlePrimaryButton={() =>
                  this.setState({
                    isOpenDropdownGroupBy: !this.state.isOpenDropdownGroupBy,
                  })
                }
                onHandleSecondaryButton={() =>
                  this.setState({
                    isOpenDropdownGroupBy: !this.state.isOpenDropdownGroupBy,
                  })
                }
                reset={labelGroupBy?.label?.length > 0 ? false : true}
                isSelected={labelGroupBy?.label?.length > 0 ? true : false}
                resetElements={this.onHandleResetGroupBy}
                isFocus={this.state.isOpenDropdownGroupBy}
                headerButton
              >
                {
                  this.state.isOpenDropdownGroupBy && (
                    <div style={{ position: 'absolute', left: '0', top: '105%' }}>
                      <Dropdown
                        data={this.props.groupBy}
                        selectedItems={(type: ISelect) => this.onHandleGroupBy(type)}
                      />
                    </div>
                  )
                }
              </ButtonMultipleChoices>
            </div>
          )}
          {this.props.withTemporality && (
            <div ref={this.refSelectTemporality} className="mr-10 priority">
              <ButtonMultipleChoices
                label={
                  labelTemporality?.label?.length > 0 ? labelTemporality?.label : "Temporalité"
                }
                color="default"
                onHandlePrimaryButton={() =>
                  this.setState({
                    isOpenDropdownTemporality: !this.state.isOpenDropdownTemporality,
                  })
                }
                onHandleSecondaryButton={() =>
                  this.setState({
                    isOpenDropdownTemporality: !this.state.isOpenDropdownTemporality,
                  })
                }
                reset={labelTemporality?.label?.length > 0 ? false : true}
                isSelected={labelTemporality?.label?.length > 0 ? true : false}
                resetElements={this.onHandleResetTemporality}
                isFocus={this.state.isOpenDropdownTemporality}
                headerButton
              >
                {
                  this.state.isOpenDropdownTemporality && (
                    <div style={{ position: 'absolute', left: '0', top: '105%' }}>
                      <Dropdown
                        data={this.props.temporality}
                        selectedItems={(type: ISelect) => this.onHandleTemporality(type)}
                      />
                    </div>
                  )
                }
              </ButtonMultipleChoices>
            </div>
          )}
          { this.props.withStatus && (
            <div ref={this.refSelectStatus} className="mr-10 priority">
              <ButtonMultipleChoices
                label={
                  labelStatus?.label?.length > 0 ? labelStatus?.label : "Status"
                }
                color="default"
                onHandlePrimaryButton={() =>
                  this.setState({
                    isOpenDropdownStatus: !this.state.isOpenDropdownStatus,
                  })
                }
                onHandleSecondaryButton={() =>
                  this.setState({
                    isOpenDropdownStatus: !this.state.isOpenDropdownStatus,
                  })
                }
                reset={labelStatus?.label?.length > 0 ? false : true}
                isSelected={labelStatus?.label?.length > 0 ? true : false}
                resetElements={this.onHandleResetStatus}
                isFocus={this.state.isOpenDropdownStatus}
                headerButton
              >
                {
                  this.state.isOpenDropdownStatus && (
                    <div style={{ position: 'absolute', left: '0', top: '105%' }}>
                      <Dropdown
                        data={this.props.statusList}
                        selectedItems={(type: ISelect) => this.onHandleStatus(type)}
                      />
                    </div>
                  )
                }
              </ButtonMultipleChoices>
            </div>
          )}
          {
            withPeriod && (
              <div className="mr-10 priority" ref={this.refSelectPeriod}>
                <ButtonMultipleChoices
                  label={
                    labelPeriod?.label?.length > 0 ? labelPeriod?.label : "Période"
                  }
                  color="default"
                  onHandlePrimaryButton={() =>
                    this.setState({
                      isOpenDropdownPeriod: !this.state.isOpenDropdownPeriod,
                    })
                  }
                  onHandleSecondaryButton={() =>
                    this.setState({
                      isOpenDropdownPeriod: !this.state.isOpenDropdownPeriod,
                    })
                  }
                  reset={labelPeriod?.label?.length > 0 ? false : true}
                  isSelected={labelPeriod?.label?.length > 0 ? true : false}
                  resetElements={this.onHandleResetPeriod}
                  isFocus={this.state.isOpenDropdownPeriod}
                  headerButton
                >
                  {this.state.isOpenDropdownPeriod && (
                    <div style={{ position: "absolute", left: "0", top: "105%" }}>
                      <Dropdown
                        data={PATTERN_DATEPICKER.filter((el) => el.label !== "")
                          .map((el) => ({
                            ...el,
                            label: t(`datepicker.${el.label}`),
                          }))
                          .filter((el: any) => {
                            return el;
                          })}
                        selectedItems={(type: ISelect) =>
                          this.onHandlePatternDate(type)
                        }
                      />
                    </div>
                  )}
                </ButtonMultipleChoices>
              </div>
            )
          }
          {
            withFilters && (
              <div className="mr-10 priority">
                <ButtonMultipleChoices
                  label={`Plus de filtres ${this.numberActiveFilters() > 0
                      ? `(${this.numberActiveFilters()})`
                      : ""
                    }`}
                  color="default"
                  onHandlePrimaryButton={() => {
                    onOpenFilters();
                    if (this.props.isFilterOpen) {
                      this.setState({ onClickFilter: true });
                    }
                  }}
                  onHandleSecondaryButton={() => onOpenFilters()}
                  reset={this.numberActiveFilters() > 0 ? false : true}
                  isSelected={this.numberActiveFilters() > 0 ? true : false}
                  resetElements={(reset: boolean) =>
                    this.onHandleResetFilters(reset)
                  }
                  headerButton
                />
              </div>
            )
          }
        </div>

        <div
          className={classnames(
            isOpenFilters ? "filters__active" : "",
            "filters",
          )}
          style={{
            transition: "all ease .8s",
            marginBottom: 0,
            marginTop: `${-document.querySelector('.filters')?.getBoundingClientRect().height}px`,
            flexFlow: "row wrap",
          }}
        >
          <React.Fragment>
            {React.cloneElement(this.props.children, {
              ...this.props,
              parent_filter: this.state.filters,
            })}
          </React.Fragment>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  let stateProps = {}

  if (state) {
    let {
      datepicker: { globalDate },
      user,
    } = stateProps;
  }

  const from = moment(globalDate?.from).format('DD/MM/YYYY')
  const to = moment(globalDate?.to).format('DD/MM/YYYY')

  return {
    user,
    globalDate: globalDate ? globalDate : null,
    date: `${from} - ${to}`,
  }
}

export default compose<any>(
  withRouter,
  withTranslation(),
  connect(mapStateToProps)
)(FilterHeader);
